import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ModalTwo.css";
import API from "../config";

const ModalTwo = props => {
  const [resultScore, setResultScore] = useState([]);
  const quizresult = props.quizresult;
  const name = props.name;
  const time = props.time;

  const navigate = useNavigate();

  const userInfo = {
    name: name,
    studentCode: time,
  };
  const submitData = {
    result: "",
  };

  submitData.result = quizresult;

  const postQuiz = async () => {
    const response = await fetch(`${API.answer}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify(submitData),
    });
    const response_json = await response.json();
    const result = response_json.results;
    return result;
  };

  useEffect(() => {
    // postQuiz().then(data => setResultScore(data));
  }, []);

  const handleSubmit = () => {
    // postQuiz();
    goToResult();
  };

  const goToResult = () => {
    // navigate("/eventOldQuiz/result", { state: { userInfo, resultScore } });
    navigate("/eventOldQuiz/result", { state: { userInfo, quizresult } });
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      animation={false}
    >
      <Modal.Header closeButton style={{ paddingBottom: "0" }}>
        <Modal.Title
          id="contained-modal-title-vcenter"
          style={{ fontSize: "2em", marginBottom: "0.5em" }}
        >
          {props.content.mainTitle}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          textAlign: "center",
          fontSize: "1.5em",
          fontWeight: "700",
          lineLeight: "1.2em",
        }}
      >
        {props.content.subTitle}
      </Modal.Body>
      <Modal.Footer style={{ marginTop: "2em" }}>
        <Button onClick={handleSubmit}>{props.content.btnText}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalTwo;
